import {
  __spreadProps,
  __spreadValues
} from "./chunk-CWMXXUWU.js";

// src/styles/themeDefaults/cardForm.tsx
var cardFormThemeBaseProps = {
  paddingY: 56,
  paddingX: 56,
  shadow: "soft",
  borderRadius: 24,
  borderWidth: 0,
  borderColor: "vlcNeutral",
  textAlign: "left",
  backgroundColor: "bg",
  smBackgroundColor: "bg",
  smBorderWidth: 0,
  defaultDescriptionTypographyMap: {
    default: {
      type: "Body Strong",
      size: "Small",
      color: "mcNeutral"
    },
    link: {
      type: "Body Strong",
      size: "Small",
      color: "text"
    }
  }
};
var cardFormThemeBase = __spreadProps(__spreadValues({}, cardFormThemeBaseProps), {
  kinds: {
    primary: {},
    secondary: {},
    tertiary: {}
  }
});
var defaultCardFormTheme = __spreadProps(__spreadValues({}, cardFormThemeBaseProps), {
  kinds: {
    primary: {},
    secondary: {
      paddingY: 40,
      paddingX: 40,
      shadow: "none",
      borderRadius: 8,
      borderWidth: 1,
      borderColor: "vlcNeutral"
    },
    tertiary: { paddingY: 56, paddingX: 40, shadow: "hard" }
  }
});

export {
  cardFormThemeBase,
  defaultCardFormTheme
};
